// extracted by mini-css-extract-plugin
export default {"root":"UsersList_root__XO7jG","label":"UsersList_label__TxZol"};